import "animate.css";

import { useEffect } from "react";

import AOS from "aos";
import "aos/dist/aos.css";

export default function Piloto() {
    useEffect(() => {
        AOS.init({ once: true });
    }, []);
    return (
        <section id="portfolio" className="portfolio section">
            <div className="container section-title" data-aos="fade-up">
                <div>
                    <span> Piloto sem Risco</span> <span className="description-title">(POC) </span>
                </div>
            </div>

            <div
                className="py-lg-16 py-10 bg-gray-200 piloto-card"
                style={{
                    background: "url(./images/course-graphics.svg) no-repeat",
                    backgroundSize: "cover",
                    backgroundPosition: "top center"
                }}
            >
                <div className="container">
                    <div className="row justify-content-center text-center">
                        <div className="col-md-9 col-12">
                            <h3 className="display-4 mb-4 ">
                                Teste a VLR <br />
                                em um piloto de 8h
                            </h3>
                            <p className="lead  px-lg-8 mb-6">
                                Se gostar, seguimos. Se não, você leva um relatório claro com próximos passos.
                            </p>

                            <div className="d-grid d-md-block">
                                {/*}
                <a href="#" class="btn btn-primary mb-2 mb-md-0 p-3"> <Icon className='me-3' path={mdiAirplaneCheck} size={1.4} />Quero um piloto de 8h <Icon className='ms-3' path={mdiAirplaneCheck} size={1.4} /></a>
                */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
